export default __webpack_public_path__ + "static/media/map.7ac3766c.png";